import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: () => true,
  handle: async ({ $router, item }) => await $router.push({ name: 'invoices-description-template-edit', params: { id: item.id } }),
});
